//@flow
import * as React from 'react';
import withHandlers from 'recompose/withHandlers';
import compose from 'recompose/compose';
import FixedDataTable from 'common/components/core/table/FixedDataTable';
import theme from './FixedDataTable.scss';
import { Column } from 'fixed-data-table-2';
import { ButtonSwitch } from 'common/components/core/switch';
import _ from 'lodash';
import classnames from 'classnames';

const selectableFixedDataTableFactory = ({
    TableComponent = FixedDataTable
}) => {
    return compose(
        withHandlers({
            areAllRowsVerified: ({
                verifiedRowIds,
                tableData: { rows }
            }) => () => {
                if (rows.size === verifiedRowIds.length) {
                    return true;
                }
            },
            areAllRowsIgnored: ({
                ignoredRowIds,
                tableData: { rows }
            }) => () => {
                if (rows.size === ignoredRowIds.length) {
                    return true;
                }
            },
            onAllRowsVerifyChange: ({
                verifiedRowIds,
                ignoredRowIds,
                tableData: { rows },
                onTableSelectionChange
            }) => ({ isVerified }) => {
                let newVerifiedRowIds = verifiedRowIds;
                let newIgnoredRowIds = ignoredRowIds;
                const allRowIds = rows.map(row => row.get('id')).toArray();
                if (isVerified) {
                    newVerifiedRowIds = allRowIds;
                    newIgnoredRowIds = [];
                } else if (!isVerified) {
                    newIgnoredRowIds = allRowIds;
                    newVerifiedRowIds = [];
                }
                onTableSelectionChange &&
                    onTableSelectionChange({
                        verifiedRowIds: newVerifiedRowIds,
                        ignoredRowIds: newIgnoredRowIds
                    });
            },
            onRowVerifyChange: ({
                verifiedRowIds,
                ignoredRowIds,
                onTableSelectionChange
            }) => ({ isVerified, fieldId: rowId }) => {
                let newVerifiedRowIds = [...verifiedRowIds];
                let newIgnoredRowIds = [...ignoredRowIds];
                const isCurrentlyVerified = verifiedRowIds.includes(rowId);
                const isCurrentlyIgnored = ignoredRowIds.includes(rowId);
                if (isVerified) {
                    if (!isCurrentlyVerified) {
                        newVerifiedRowIds = [...newVerifiedRowIds, rowId];
                    }
                    if (isCurrentlyIgnored) {
                        _.remove(
                            newIgnoredRowIds,
                            ignoredRowId => ignoredRowId === rowId
                        );
                    }
                } else if (!isVerified) {
                    if (!isCurrentlyIgnored) {
                        newIgnoredRowIds = [...newIgnoredRowIds, rowId];
                    }
                    if (isCurrentlyVerified) {
                        _.remove(
                            newVerifiedRowIds,
                            verifiedRowId => verifiedRowId === rowId
                        );
                    }
                }
                onTableSelectionChange &&
                    onTableSelectionChange({
                        verifiedRowIds: newVerifiedRowIds,
                        ignoredRowIds: newIgnoredRowIds
                    });
            }
        }),
        withHandlers({
            renderCheckbox: ({
                verifiedRowIds,
                ignoredRowIds,
                tableData: { rows },
                onRowVerifyChange,
                t
            }) => checkboxProps => {
                const { columnKey, rowIndex } = checkboxProps;
                const inputRecord = rows.get(rowIndex);
                const rowId = inputRecord.get('id'); // taking the first one as id
                const isVerified = verifiedRowIds.includes(rowId);
                const isIgnored = ignoredRowIds.includes(rowId);
                return (
                    <ButtonSwitch
                        key={`${columnKey}.${rowIndex}`}
                        fieldId={rowId}
                        isVerified={isVerified}
                        isIgnored={isIgnored}
                        onChange={onRowVerifyChange}
                        verifyBtnTooltip={t('keepNew')}
                        ignoreBtnTooltip={t('ignore')}
                        className={theme.cell}
                    />
                );
            }
        }),
        withHandlers({
            renderCheckboxHeader: ({
                areAllRowsVerified,
                areAllRowsIgnored,
                t,
                onAllRowsVerifyChange
            }) => () => {
                return (
                    <ButtonSwitch
                        className={classnames(
                            theme.tableHeader,
                            theme.switchHeader
                        )}
                        onChange={onAllRowsVerifyChange}
                        verifyBtnTooltip={t('keepAllNew')}
                        ignoreBtnTooltip={t('ignoreAll')}
                        isVerified={areAllRowsVerified()}
                        isIgnored={areAllRowsIgnored()}
                    />
                );
            }
        }),
        withHandlers({
            renderExtraColumns: ({
                renderCheckbox,
                renderCheckboxHeader
            }) => () => {
                return (
                    <Column
                        columnKey={'checkbox'}
                        header={renderCheckboxHeader}
                        cell={renderCheckbox}
                        width={66}
                        fixed
                    />
                );
            }
        })
    )(TableComponent);
};
const SelectableFixedDataTable = selectableFixedDataTableFactory({});

export { SelectableFixedDataTable };
export default SelectableFixedDataTable;
